const host = 'http://corpus.ied.edu.hk'
const api = __DEV__
  ? {
    GET_FILES_API: host + '/ace/view/get_files.php',
    READ_FILE_API: host + '/ace/view/read_file.php',
    AUDIO_PREFIX_URL: host + '/ace/view/audio/'
  }
: {
    GET_FILES_API: '/ace/view/get_files.php',
    READ_FILE_API: '/ace/view/read_file.php',
    AUDIO_PREFIX_URL: '/ace/view/audio/'
  }

export default api



// WEBPACK FOOTER //
// ./src/api.js